function isSectionB(section) {
  const key = String(section || '').toLowerCase();
  return key === 'section_b' || key === 'b';
}

function isLsatKind({ section, kind } = {}) {
  const key = String(kind || section || '').toLowerCase();
  return key === 'lsat';
}

export function buildLnatTopicOverviewRows({
  section,
  kind,
  questionCount,
  timed,
  durationMinutes,
} = {}) {
  const count = Number(questionCount) || 0;
  if (isLsatKind({ section, kind })) {
    return [{
      section: 'LSAT',
      questions: count,
      time: timed ? `${durationMinutes} minutes` : 'Untimed',
    }];
  }
  const isB = isSectionB(section);
  return [{
    section: isB ? 'Section B : Essay' : 'Section A : Multiple Choice',
    questions: count,
    time: timed ? `${durationMinutes} minutes` : 'Untimed',
  }];
}

export function buildLnatTopicOverviewBodyCopy({
  section,
  kind,
  questionCount,
  timed,
  durationMinutes,
} = {}) {
  const count = Number(questionCount) || 0;
  if (isLsatKind({ section, kind })) {
    return [{
      text: `This is LSAT practice. There are ${count} LSAT-style multiple-choice questions${timed ? ` and ${durationMinutes} minutes` : ' and it is untimed'}.`,
    }];
  }
  const isB = isSectionB(section);
  if (isB) {
    return [{
      text: `This practice consists of one section: Section B. There are ${count} essay prompts${timed ? ` and ${durationMinutes} minutes` : ' and it is untimed'}.`,
    }];
  }
  return [{
    text: `This practice consists of one section: Section A. There are ${count} multiple-choice questions${timed ? ` and ${durationMinutes} minutes` : ' and it is untimed'}.`,
  }];
}

export function buildLsatPracticeInstructionBody({ questionCount, timed, durationMinutes } = {}) {
  const count = Number(questionCount) || 0;
  return [{
    text: `This is LSAT practice. Work through this set of ${count} LSAT-style questions${timed ? ` in ${durationMinutes} minutes` : ' (untimed)'}.`,
  }];
}
